<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Fixed Asset Maintenance Detail 
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
          <b-col lg="7">
                <b-row >
                  <b-col lg="5" >
                    <b-input-group >
                        <b-input-group-prepend><label>Fixed Asset Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.catgname" readonly=""></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Fixed Asset Name</label></b-input-group-prepend>
                    <b-form-input v-model="model.asdesc" ></b-form-input>
                </b-input-group>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year Made&nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial" placeholder="Serial Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="model.vendorinfo" placeholder="Vendor Code | Vendor Name" readonly></b-form-input>                                        
                </b-input-group>
                <b-row no-gutters>
                  <b-col lg="7" >
                    <b-input-group >
                        <b-input-group-prepend><label>Warranty Note/Desc.</label></b-input-group-prepend>
                        <b-form-input v-model="model.txtgaransi"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Expired Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tglgaransi" type="date" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row >
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input  v-model="model.asdatacq" type="date" readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Reference Doc.#</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomorpo" readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

          </b-col>
          <b-col lg="5">
                <b-input-group >
                      <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                      <b-form-checkbox  class="mt-2" v-model="model.use_procure" value=1 unchecked-value=0>Public Asset (used together in a crowd) </b-form-checkbox>
                </b-input-group>
                <b-row no-gutters>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>User of Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asuser" placeholder="usage remark"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">
                    <b-input-group >
                        <b-form-input readonly v-model="model.crewinfo"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" :disabled="(model.Penyusutan >0 )">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Location of Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.aslocat" placeholder="location remark"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">
                    <b-input-group >
                        <b-form-input readonly v-model="model.lokasiinfo"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" :disabled="(model.Penyusutan >0 )">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <hr v-if="(odoMeters.length<2)">
                <b-input-group >
                    <b-input-group-prepend><label class="spesial">Usability Status</label></b-input-group-prepend>
                    <b-form-select v-model="model.status_id" :plain="true" :options="asetstatus" ></b-form-select>
                </b-input-group>
                <b-input-group v-for="row in odoMeters" :key="row.assetPart">
                    <b-input-group-prepend><label class="spesial">Current OdoMeter {{row.assetPart}}</label></b-input-group-prepend>
                    <b-form-input v-model="row.uomValue" type="number" ></b-form-input>
                    <b-form-input v-model="row.uomCode" readonly class="ml-1" placeholder="KM or HOUR or CYCLE" ></b-form-input>
                </b-input-group>
          </b-col>
      </b-row>
          <b-card title="MAINTENANCE BOOK/STATUS">
            <b-table
                class="mb-0"
                ref="tblGroup"
                outlined
                striped hover small 
                style="font-size:smaller;"
                :items="asset.list"
                :fields="asset.fields"
                :current-page="asset.page"
                :per-page="asset.limit"
              >
                  <template v-slot:cell(index)="data">
                    {{data.index + 1}}
                  </template>
                  <template v-slot:cell(tanggal)="data">
                    <span v-if="(data.item.tanggal)">{{data.item.tanggal| moment('D-MMM-YY')}}</span>
                  </template>
                  <template v-slot:cell(uomValue)="data">
                    <span v-if="(data.item.uomValue)">{{data.item.uomValue}} {{data.item.uomCode}} </span>
                  </template>

                  <template v-slot:cell(action)="data">
                    <div class="text-center">
                    <a href="javascript:void(0)" class="text-danger" @click="delAsset(data.index)">
                      <i class="fa fa-trash"></i>
                    </a>
                    </div>
                </template>
              <template v-slot:row-details="row">
                <b-card no-body class="row-details-form">
                    <b-row class="ml-2 mt-2 mr-2">
                        <b-col cols="6">
                        <b-row>
                          <b-col cols="6">
                            <b-input-group >
                              <b-input-group-prepend><label>Maintenance Document#</label></b-input-group-prepend>
                              <b-form-input v-model="assetObj.referDoc" readonly></b-form-input>
                              <b-input-group-append>
                              <b-btn text="Button" @click="lkuMaintenguideShow=true" >
                                  <i class="fa fa-search"></i>
                              </b-btn>
                              </b-input-group-append>
                            </b-input-group>
                          </b-col>
                        </b-row>
                        <b-input-group >
                            <b-input-group-prepend><label>Maintenance Name</label></b-input-group-prepend>
                            <b-form-input v-model="assetObj.inspectName" readonly ></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Work/Task Detail</label></b-input-group-prepend>
                            <b-form-textarea :rows="3" :max-rows="10" v-model="assetObj.inspectDetail" readonly></b-form-textarea>
                        </b-input-group>
                        <b-row>
                          <b-col cols="5">
                              <b-input-group >
                                  <b-input-group-prepend><label>Repetitif Interval</label></b-input-group-prepend>
                                  <b-form-input v-model="assetObj.intervalCal" type="number"  readonly></b-form-input>
                                  <b-input-group-append> <span class="input-group-text">DAYS</span></b-input-group-append>
                              </b-input-group>
                          </b-col>
                          <b-col cols="7">
                              <b-input-group >
                                  <b-input-group-prepend><span class="pt-2 mr-1">Repetitif in OdoMeter</span></b-input-group-prepend>
                                  <b-form-input v-model="assetObj.intervalUom" type="number" readonly></b-form-input>
                                  <b-form-input v-model="assetObj.intervalUomCode" readonly class="ml-1" ></b-form-input>
                              </b-input-group>
                          </b-col>
                        </b-row>

                        </b-col>
                        <b-col cols="6">
                            <b-input-group >
                              <b-input-group-prepend><label>Component/Part &nbsp;</label></b-input-group-prepend>
                              <b-form-input v-model="assetObj.assetPart" placeholder="Body/Engine/Electronic" readonly></b-form-input>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label>Last Maintenance Date</label></b-input-group-prepend>
                                <b-form-input v-model="assetObj.tanggal" type="date" :state="!$v.assetObj.tanggal.$error"></b-form-input>                                        
                                <b-input-group-prepend><span class="input-group-text"> or firsttime usage date</span></b-input-group-prepend>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label>Last Recorded OdoMeter</label></b-input-group-prepend>
                                <b-form-input v-model="assetObj.uomValue" type="number" placeholder="current OdoMeter" ></b-form-input>
                                <b-form-input v-model="assetObj.intervalUomCode" class="ml-1" placeholder="KM or Hour or Cycle"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center mb-2">
                        <b-button class="btn btn-info mr-1" @click="saveAsset()">Save</b-button>
                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Close</b-button>
                    </b-row>
                </b-card>
              </template>                        

            </b-table>
            <b-row>
              <b-col cols="5">
                <b-row>
                  <b-button size="sm" class="btn btn-primary ml-3" @click="addAsset" :disabled="!(model.asetkey)">Add Maintenance Doc.</b-button>                          
                  <div class="ml-2">
                    Showing
                    {{(asset.page - 1) * asset.limit + 1}}
                    to
                    {{asset.page * asset.limit}}
                    of
                    {{asset.total}}
                    entries
                  </div>    
                </b-row>                    
              </b-col>
              <b-col cols="3">            
                <b-row class="ml-2 mt-2">
                  <span class="pt-1 pr-2">Limit per page</span>
                  <input type="number" style="width:80px;" v-model="asset.limit"/>
                </b-row>
              </b-col>
              <b-col cols="4">            
                <b-pagination
                  align="right"
                  :total-rows="asset.total"
                  :per-page="asset.limit"
                  v-model="asset.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>

      <b-row class="justify-content-center mt-2">
          <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>   
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>        
        <b-modal v-model="lkuMaintenguideShow" size="lg" :hide-footer="true" title="List of Maintenance Manual" :centered="true">
            <lku-maintenguide @click="onSelectLkuMaintenguide" :assetCatgId="model.catgid" :assetCatgName="model.catgname" :key="model.catgid"></lku-maintenguide>
        </b-modal>        

  </div>
</template>

<style lang="scss">
    .table-wraper {
         width:100%;
         height:380px;
         overflow-x: auto;
         overflow-y: auto;
        border: 1px solid silver;
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
            .spesial {
              width: 250px !important;;
              text-align: right !important;
                padding-right: 10px !important;
            }

        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }    
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import lkuCrew from "../lookup/lkuCrewlazzy";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import lkuMaintenguide from "../lookup/lkuMaintenguide";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
import mmasset from "../../apis/maintenasset";
toastr.init();

export default {
  components: { lkuCrew, lkuFixedasset, lkuMaintenguide},
  mixins: [validationMixin],
  validations: {
    model: {
        asetkey: { required },
        asdesc: { required },
    },
    assetObj: {
        inspMstrKey: { required },
        tanggal: { required },
    },

  },   
  data() {
    return {
      saveEnabled: true,
      lkuCrewData:{},
      lkuCrewShow:false,
      lkuFixedAssetData:{},
      lkuFixedAssetShow: false,
      lkuMaintenguideShow: false,
      showDepreciation:false,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      model:{asdesc:'',catgid:'',kurstrx : 1, matauang:this.$store.state.user.matauang},
      totalDb:0,
      totalCr:0,
      totalRow:0,
      currency:[],
      categories:[],
      asetstatus:[],
      uanguser:this.$store.state.user.matauang,
        asset: {
            list: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                  key: "referDoc",
                  label: "Maintenance Doc.#",
                  thStyle: "width:140px",
                  sortable: true
                },
                {
                  key: "inspectName",
                  label: "Maintenance/Inspection Name",
                },
                {
                  key: "intervalCal",
                  label: "Repetitif Interval",
                  thClass: "text-center",
                  tdClass: "text-center",
                  thStyle: "width:150px",
                  sortable: true
                },
                {
                  key: "assetPart",
                  label: "Part/Component",
                  thStyle: "width:120px",
                  thClass: "text-center",
                  tdClass: "text-center",
                  sortable: true
                },
                {
                  key: "tanggal",
                  thStyle: "width:90px",
                  label: "Last Maintenance",
                  sortable: true
                },
                {
                  key: "uomValue",
                  label: "OdoMeter",
                  thStyle: "width:80px",
                },
                {
                  key: "action",
                  label: "action",
                  thClass: "text-center",
                  tdClass: "text-center",
                },

            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        assetObj:{asetkey:'', tanggal:'', inspMstrKey:''}, 
        odoMeters:['']       
    }
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
      invalidAssetObj() {
        this.$v.assetObj.$touch();
        return this.$v.assetObj.$invalid;
      },
  },
  created: async function (){
      if (this.$route.params.asetkey)  {
          toastr.info('Loading Fixed Asset Detail, please wait')
          try {
            const [a,data] = await Promise.all([await mmasset.asetstatus(), mmasset.detail(this.$route.params)]);
            this.asetstatus = a;
            const row = data[0];
            this.asset.list = data[1];
            this.asset.total=this.asset.list.length;
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.asdatacq = row.asdatacq ? moment(row.asdatacq).format('YYYY-MM-DD') : '';
            // this.model.asdatuse = row.asdatuse ? moment(row.asdatuse).format('YYYY-MM-DD') : '';
            this.model.tglgaransi = row.tglgaransi ? moment(row.tglgaransi).format('YYYY-MM-DD') : '';
            this.odoMeters = data[2];
            const odoDistinct  = data[3];
            odoDistinct.forEach((uom) => {
                const odo = this.odoMeters.find(o => (o.assetPart || '') === (uom.assetPart || '')); 
                if (!(odo)) {
                  this.odoMeters.push({
                        maintMeterKey: '',
                        uomValue: '', 
                        uomCode: uom.intervalUomCode,
                        assetPart: uom.assetPart,
                        asetkey: this.model.asetkey
                        })
                }
            });

            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
            const [a] = await Promise.all([await mmasset.asetstatus()]);
            this.asetstatus = a;
            // this.categories=b;
      }
  },
  methods: {
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    onSelectLkuFixedAsset: async function(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;

        this.assetObj.asetkey = lkuData.selected.asetkey;
        this.assetObj.asetid = lkuData.selected.asetid;
        this.assetObj.asdesc = lkuData.selected.asdesc;
        this.assetObj.catgname = lkuData.selected.catgname;
        this.assetObj.catgid = lkuData.selected.catgid;
        this.assetObj.asmodel = lkuData.selected.asmodel;
          toastr.info('Loading  Detail Maintenance Manual, please wait')
          try {
            const data = await mmasset.detail({asetkey:lkuData.selected.asetkey});  
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.asset.list = data[1];
            this.odoMeters = data[2];
            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);                              
          }

    },
    onSelectLkuMaintenguide(_selected) {
      const mmAda = this.asset.list.find(c => c.inspMstrKey == _selected.inspMstrKey)
      if (mmAda) {
        toastr.warn(`${_selected.referDoc} | ${_selected.inspectName} already Applied`);
      } else {
        for (var key in _selected) {
            this.assetObj[key] = _selected[key];
        }
        this.$forceUpdate();
        this.lkuMaintenguideShow=false;
      }
    },    
    onSelectLkuCrew:  function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.model.crewkey = lkuData.selected.crewkey;
        this.model.crewnik = this.model.crewnik;
        this.model.jabatan = lkuData.selected.jabatan;
        this.model.departemen = this.model.departemen;
        this.lkuCrewShow=false;
    },
    addAsset : function () {
        const obj={_showDetails:true};
        this.asset.selected = obj;
        for (var key in this.assetObj) {
            this.assetObj[key] = '';
        }
        this.asset.list.push(obj);
        this.asset.total=this.asset.list.length;
    },
    delAsset: function (index) {
        if (index > -1) {
          // this.asset.list.splice(index, 1);
            const posisi = (this.asset.page-1)*this.asset.limit;
            this.asset.list.splice(posisi+index, 1);
        }
        this.asset.total=this.asset.list.length;
    },
    saveAsset: function(callback){
        if (this.invalidAssetObj) {
            console.log('validation contact : ', this.$v.assetObj);
            console.log('selected contact : ',this.assetObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            for (var key in this.assetObj) {
                this.asset.selected[key] = this.assetObj[key];
            }
            this.asset.selected._showDetails=false;
            if (callback) callback();
        }
    },    

    save: async function () {
        // console.log('Save Clicked');
        // if (!this.saveEnabled) {
        //     toastr.error('View mode cannot be Saved');
        //     return;
        // }
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              let data= {}
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.tglgaransi = (this.model.tglgaransi) ? moment(this.model.tglgaransi).format('YYYY-MM-DD') : '';
              // data.asdatacq = moment(this.model.asdatacq).format('YYYY-MM-DD');
              // data.asdatuse = (this.model.asdatuse) ? moment(this.model.asdatuse).format('YYYY-MM-DD') : '';
              // data.tglAkhirDepr = (this.model.tglAkhirDepr) ? moment(this.model.tglAkhirDepr).format('YYYY-MM-DD')  : '';

              data.assets = this.asset.list.reduce((newArr, item) => {
                  if ((item.inspMstrKey || '') != '') {
                    item.tanggal= moment(item.tanggal).format('YYYY-MM-DD');
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              data.odoMeter = this.odoMeters.reduce((newArr, item) => {
                  if (item.uomValue) {
                      // newArr.push({
                      //   maintMeterKey: item.maintMeterKey,
                      //   uomValue: item.uomValue, 
                      //   uomCode: item.intervalUomCode,
                      //   assetPart: item.assetPart,
                      //   asetkey: this.model.asetkey
                      //   });
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              await mmasset.save(data);
              toastr.success("Complete successfully", "Save Amortization");
              this.close();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
        }
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'fixedasset.maintassetmmfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'fixedasset.home'});
      }
    },    
  }
};
</script>
